import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
var _excluded = ["text"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { Button } from "../../Button/Button/Button";
import { HeadingText } from "../../Text/HeadingText/HeadingText";
import { Image } from "../../Image/Image/Image";
import { Text } from "../../Text/Text/Text";
import styles from "./PopupContentBlock.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var PopupContentBlock = function PopupContentBlock(_ref) {
  var image = _ref.image,
    _ref$headline = _ref.headline,
    headline = _ref$headline === void 0 ? '' : _ref$headline,
    _ref$subhead = _ref.subhead,
    subhead = _ref$subhead === void 0 ? '' : _ref$subhead,
    _ref$body = _ref.body,
    body = _ref$body === void 0 ? '' : _ref$body,
    cta = _ref.cta;
  var _ref2 = cta || {},
    text = _ref2.text,
    otherProps = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/_jsxs("div", {
    className: styles.block,
    children: [(image === null || image === void 0 ? void 0 : image.src) && /*#__PURE__*/_jsx(Image, {
      alt: image.alt,
      className: styles.image,
      src: image.src
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.content,
      children: [/*#__PURE__*/_jsx(HeadingText, {
        ariaLevel: 2,
        className: styles.headline,
        richText: true,
        typog: "subhead3",
        children: headline
      }), /*#__PURE__*/_jsx(Text, {
        className: styles.subhead,
        richText: true,
        typog: "bodycopySmall",
        children: subhead
      }), /*#__PURE__*/_jsx(Text, {
        className: styles.body,
        richText: true,
        typog: "bodycopySmall",
        children: body
      }), (cta === null || cta === void 0 ? void 0 : cta.text) && cta.url && /*#__PURE__*/_jsx("div", {
        className: styles.cta,
        children: /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
          size: "medium"
        }, otherProps), {}, {
          children: text
        }))
      })]
    })]
  });
};